import React from 'react';

import LinkIcon from '@mui/icons-material/Link';
import { Chip, ListItemText, Stack, Typography } from '@mui/material';

import { AdminNoticeResult } from 'stores/NoticeAdminStoreAdapter';
import { formatDateTime } from 'utils/DateTimeFormatter';

type NoticeListItemProps = {
  notice: AdminNoticeResult;
};

const NoticeListItem: React.FC<NoticeListItemProps> = ({ notice }) => {
  const hasLink = !!notice.externalLink || !!notice.internalLink;

  return (
    <ListItemText
      primary={
        <Stack direction="row" alignItems="center" justifyContent="space-between" component="span">
          <Typography
            variant="body2"
            fontWeight={500}
            noWrap
            component="span"
            sx={{ flex: 1, minWidth: 0 }}
          >
            {notice.title}
          </Typography>
          <Stack direction="row" spacing={0.5} sx={{ ml: 1, flexShrink: 0 }}>
            {notice.priority <= 3 && (
              <Chip
                label={`P${notice.priority}`}
                size="small"
                color={notice.priority === 1 ? 'error' : notice.priority === 2 ? 'warning' : 'info'}
                sx={{ height: 20, fontSize: '0.7rem', fontWeight: 700 }}
              />
            )}
            {hasLink && <LinkIcon sx={{ fontSize: 18, color: 'text.secondary', flexShrink: 0 }} />}
            <Chip
              label={notice.isResolved ? '解決済' : '未解決'}
              size="small"
              color={notice.isResolved ? 'success' : 'warning'}
              variant="outlined"
              sx={{ height: 20, fontSize: '0.7rem', fontWeight: 700 }}
            />
          </Stack>
        </Stack>
      }
      secondary={
        <Typography variant="caption" color="text.secondary" component="span">
          {formatDateTime(notice.createdAt)}
        </Typography>
      }
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    />
  );
};

export default NoticeListItem;
